/**
 * Row cap for the One Click Launch tab.
 *
 * The OCL table fetches a single page at this size and exposes no
 * pagination, so every downstream consumer — the header counter, the
 * Launch Scope Summary, and the launch submission payload itself —
 * only ever sees this many rows. `OclRowLimitAlert` warns the user
 * when their filter matches more than this, which is why the fetch
 * and the alert threshold have to read from the same constant.
 */
export const OCL_PAGE_SIZE = 500;
